import React, { useEffect } from "react";
import { View, Text, Image, TouchableOpacity, StatusBar } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { useBackButtonHandler } from "../../hooks/useBackHandler";
import { handleBackButton } from "../../components/BackButtonAlert";
import styles from "../../../UserProfile/styles/styles";
import dimensions from "../../../../globalStyles/dimensions";
import { Colors } from "../../../../globalStyles/ColorConfig";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import { registerForPushNotificationsAsync } from "../../../../components/InAppNotification/Notification";
import { dispatch } from "../../../../redux/store";
import { setExpoToken } from "../../../../redux/auth/authSlice";

const BasicInfo = () => {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();
  useBackButtonHandler(handleBackButton, [navigation]);

  useEffect(() => {
    registerForPushNotificationsAsync()
      .then((token:any) => {
        console.log(token,"token")
        dispatch(setExpoToken(token))
      })
      .catch((err:any) => {
        console.log(err);
      });
  }, []);

  return (
    <View
      style={{
        height: "100%",
        width: "100%",
        paddingBottom: insets.bottom,
      }}
    >
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"light-content"}
      />
      <Image
        source={{
          uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/basicinfo.webp",
        }}
        resizeMode="cover"
        style={{
          width: "100%",
          height: dimensions.windowHeight / 1.2,
        }}
      />
      <View style={{ position: "absolute", bottom: 0 }}>
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,1)"]}
          style={{
            width: dimensions.windowWidth,
            height: dimensions.windowHeight / 2,
            bottom: 0,
            zIndex: 2,
          }}
        />
        <View
          style={{
            backgroundColor: Colors.black100,
            paddingHorizontal: 16,
            paddingBottom: 10,
          }}
        >
          <Text
            style={[
              styles.showOffText,
              GlobalStyles.heading2,
              { color: "white",
              fontFamily:"EBGaramondMedium",
              letterSpacing: -0.3,
              fontSize:36,
              lineHeight:38,
              paddingHorizontal:10
            },
            ]}
          >
            Let's get started
          </Text>
          <TouchableOpacity
            style={{
              backgroundColor: Colors.black100,
              borderRadius: 40,
              marginVertical: dimensions.marginVertical,
              borderWidth: 0.5,
              borderColor: Colors.grey300,
              justifyContent: "center",
              paddingVertical: 16,
            }}
            onPress={() => navigation.navigate("onboard-name" as never)}
          >
            <Text
              style={[
                GlobalStyles.bodyText,
                { color: "#BEBEBE", textAlign: "center",fontFamily:"InterSemiBold",
                letterSpacing: -0.16, 
              },
              ]}
            >
              Enter basic info
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default BasicInfo;
